import { useSessionStorage, useSVGContent } from '@healthhub/react-ui';
import { useEffect, useState } from 'react';

import { ConnectionError } from '@shared/assets';
import { CONNECTION_ERROR_BASE64_SESSION_KEY } from '@shared/constants/constants';
import { convertToBase64 } from '@shared/utils/string';

export default function useOffline() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const [value, setValue] = useSessionStorage<string>(CONNECTION_ERROR_BASE64_SESSION_KEY);
  const noInternetSVG = useSVGContent(ConnectionError, value);

  const onOffline = () => {
    setIsOffline(true);
  };

  const onOnline = () => {
    setIsOffline(false);
  };

  useEffect(() => {
    if (noInternetSVG.content) {
      setValue(convertToBase64(noInternetSVG.content));
    }
  }, [noInternetSVG, setValue]);

  useEffect(() => {
    window.addEventListener('offline', onOffline);
    window.addEventListener('online', onOnline);

    return () => {
      window.removeEventListener('offline', onOffline);
      window.removeEventListener('online', onOnline);
    };
  }, []);

  return isOffline;
}
